<svg viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg">
<line x1="5.5" y1="1.5" x2="13.5" y2="1.5" stroke="currentColor" stroke-linecap="round"/>
<line x1="5.5" y1="11.5" x2="13.5" y2="11.5" stroke="currentColor" stroke-linecap="round"/>
<rect x="0.5" y="0.5" width="2" height="2" rx="0.5" stroke="currentColor"/>
<line x1="5.5" y1="6.5" x2="13.5" y2="6.5" stroke="currentColor" stroke-linecap="round"/>
<rect x="0.5" y="5.5" width="2" height="2" rx="0.5" stroke="currentColor"/>
<rect x="0.5" y="10.5" width="2" height="2" rx="0.5" stroke="currentColor"/>
</svg>
